module.exports = __webpack_public_path__ + "static/img/designed.29cddb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/designed.png
// module id = thHb
// module chunks = 0